<template>
    <div id="main">
        <!-- @71283 - Modal para cadastro de Cultura (apenas descrição) a partir da tela de Cultivar -->
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('novo-cultura') }}
                        </h1>
                    </div>
                    <div class="header-buttons">
                        <button class="delete-btn" type="button" @click="onFecharModal">
                            {{ $t('cancelar') }}
                        </button>
                        <button
                            v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)"
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-3">
                            <v-input
                                :id="generateId(2)"
                                ref="idculturaerpInput"
                                v-model="cultura.idtipoculturaerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                :invalid="!cultura.idtipoculturaerp"
                                tooltipLabel="cod-ref"
                            />
                        </div>
                        <div class="column is-9">
                            <v-input
                                :id="generateId(1)"
                                ref="descricaoInput"
                                v-model="cultura.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="descricao"
                                :invalid="invalidCultura"
                                :onBlurFunction="validateCultura"
                                :msg="invalidCulturaMsg"
                                :tooltipLabel="'informacao-cultivar'"
                                tooltipSize="is-small"
                                tooltipPosition="is-right"
                                uppercase
                                :required="true"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CulturaService from '@/services/agro/CulturaService';
import CulturaValidation from '@/services/validations/agro/CulturaValidation';
import Message from '@/models/Message';

export default {
    props: {
        idTipoCultura: 0,
        abrev: {
            type: String,
            default: 'agro',
        },
        isAgro: {
            type: Boolean,
            default: true,
        },
        isVenda: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            culturaService: new CulturaService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            isSaving: false,
            cultura: {
                id: null,
                idtipoculturaerp: '',
                descricao: null,
            },
            isUpdate: false,
            validation: false,
            invalidCultura: false,
            invalidCulturaMsg: 'msg-campo-obrigatorio',
        };
    },
    created() {
        if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess('agro', 'agro-cadastros', 'agro-cultura');
        } else if (this.isVenda) {
            this.permissao = this.hasPermissionAccess('vendas', 'crm', 'ven-cultura');
        }

        this.validation = new CulturaValidation(this.msgs);

        if (!this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'cultura' },
            });
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        save() {
            this.isLoading = true;

            if (this.validation.validate(this.cultura, this.$refs)) {
                let culturaTemp = Object.assign({}, this.cultura);
                culturaTemp = this.mapTosave(culturaTemp);
                this.isSaving = true;

                this.culturaService.save(culturaTemp, this.abrev).then((value) => {
                    if (value.message == null) {
                        let msg = 'msg-tipocultura-salva';
                        this.msgs.push(new Message('success', msg, true));

                        this.promptTelaCultura(value.content);
                    } else {
                        if (this.$t(value.message)) {
                            this.msgs.push(new Message('alert', value.message, true));
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    }
                    this.isSaving = false;
                    this.isLoading = false;
                });
            } else {
                this.runValidations();
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                this.isLoading = false;
            }
        },
        mapOnSave(value) {
            return {
                id: value.idtipocultura,
                descricao: value.descricao,
            };
        },
        redirectToList() {
            setTimeout(() => {
                this.$router.push({
                    name: `${this.abrev}-cultivar`,
                });
            }, 1000);
        },
        promptTelaCultura(culturaTemp) {
            this.$root.confirm({
                message: this.$t('confirmar-tela-cultura'),
                onConfirm: (_) => {
                    this.$router.push({
                        name: `${this.abrev}-cultura-edit`,
                        params: { id: culturaTemp.idtipocultura },
                        query: { tela: `${this.abrev}-cultivar-edit`, id: this.$route.params.id },
                    });
                },
                onCancel: (_) => {
                    this.onFecharModalComDados(culturaTemp);
                },
            });
        },
        validateCultura() {
            if (this.isNull(this.cultura.descricao)) {
                this.invalidCultura = true;
                this.invalidCulturaMsg = 'msg-campo-obrigatorio';
            } else {
                this.invalidCultura = false;
            }
        },
        runValidations(focusedOut = false) {
            if (focusedOut) {
                // Utilizado para ativar a validação dos campos ao carregar os dados de alteração
                Object.entries(this.$refs).forEach(([key, value]) => {
                    value.focusedOut = true;
                });
            }
            // Ao realizar o focusedOut no arquivo validation, as funções de validate não são chamadas, tendo assim que faze-las manualmente para poder apresentar os erros nos campos
            this.validateCultura();
        },
        onFecharModal() {
            this.$emit('fecharModal', true);
        },
        onFecharModalComDados(culturaTemp) {
            this.$emit('fecharModal', true);
            this.$router.push({
                name: `${this.abrev}-cultivar-edit`,
                params: { id: this.$route.query['id'] },
                query: { idCultura: culturaTemp.idtipocultura },
            });
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 20px 20px !important;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}
</style>
